import { AuthService } from './auth.service';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getCountries() {
    return this.http.get<any>(`${environment.apiUrl}/countries`)
      .pipe(map(response => {
        if (response && response.token) {
          this.authService.setNewToken(response.token);
          this.authService.setUserData(response.user);
        }
        return response;
      }));
  }

}
